import React, { useEffect } from "react";
import Footer from "@/components/Footer";
import Logo from "@/assets/logo.png";
import LoginForm from "./form";
import LoginBanner from "./banner";
import styles from "./style/index.module.less";

function Login() {
  useEffect(() => {
    document.body.setAttribute("arco-theme", "light");
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement("img", {
    src: Logo,
    alt: "logo",
    width: 20,
    height: 20,
    className: styles["logo-img"]
  }), /*#__PURE__*/React.createElement("div", {
    className: styles["logo-text"]
  }, "\u540E\u53F0\u7BA1\u7406\u7CFB\u7EDF")), /*#__PURE__*/React.createElement("div", {
    className: styles.banner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["banner-inner"]
  }, /*#__PURE__*/React.createElement(LoginBanner, null))), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["content-inner"]
  }, /*#__PURE__*/React.createElement(LoginForm, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Footer, null))));
}

Login.displayName = "LoginPage";
export default Login;